import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'

import { AppRoutingModule } from './app-routing.module'
import { SharedModule } from 'src/core/shared.module'
import { AppSettingsService, KeycloakSettings } from './services/app-settings.service'
import {
    AutoRefreshTokenService,
    CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    customBearerTokenInterceptor,
    provideKeycloak,
    UserActivityService,
    withAutoRefreshToken
} from 'keycloak-angular'
import Keycloak from 'keycloak-js'
import { AppComponent } from './app.component'
import { ErrorComponent } from './components/error/error.component'
import { LoadingStateService } from './services/app-loading-state.service'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { QueryManagerService } from './services/query-manager.service'
import { KeycloakOnLoad } from 'keycloak-js'

const settingsService = new AppSettingsService()

export function authConfig(): KeycloakSettings {
    return settingsService.getConfig('auth', window.env)
}

@NgModule({
    declarations: [AppComponent, ErrorComponent],
    bootstrap: [AppComponent],
    imports: [BrowserModule, BrowserAnimationsModule, AppRoutingModule, SharedModule],
    providers: [
        LoadingStateService,
        QueryManagerService,
        provideKeycloak({
            config: {
                realm: authConfig().configOptions.realm,
                url: authConfig().configOptions.url,
                clientId: authConfig().configOptions.clientId
            },
            initOptions: {
                onLoad: authConfig().initOptions.onLoad as KeycloakOnLoad,
                checkLoginIframe: authConfig().initOptions.checkLoginIframe
            },
            features: [
                withAutoRefreshToken({
                    onInactivityTimeout: 'logout',
                    sessionTimeout: 3600000 // 1 hour
                })
            ],
            providers: [AutoRefreshTokenService, UserActivityService]
        }),
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([customBearerTokenInterceptor])),
        {
            provide: CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
            useValue: [
                {
                    shouldAddToken: async (req: Request, _: Response, keycloak: Keycloak) => {
                        // Only add tokens to API requests going to our backend
                        // Skip for third-party API calls
                        const apiUrl = window.env.api_url
                        return keycloak.authenticated && (req.url.startsWith(apiUrl) || req.url.startsWith('/api/'))
                    }
                }
            ]
        }
    ]
})
export class AppModule {}
